var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#39BF8F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.7,54.2h-5.8v-6.8c3.4-1.1,5.8-4.2,5.8-7.9v-5.9c0-4.6-3.8-8.4-8.4-8.4S44,28.9,44,33.5v5.9 c0,3.7,2.4,6.8,5.7,7.9v6.8h-9.1V15.1c0-6.7-3.8-10.5-10.4-10.5H13.9C7.3,4.6,3.5,8.4,3.5,15.1v39.1H3.3c-1.4,0-2.6,1.2-2.6,2.6 c0,1.4,1.2,2.6,2.6,2.6h48.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h8.3c1.4,0,2.6-1.2,2.6-2.6C63.4,55.4,62.2,54.2,60.7,54.2z  M49.2,33.5c0-1.8,1.4-3.1,3.1-3.1c1.8,0,3.1,1.4,3.1,3.1v5.9c0,1.7-1.4,3.1-3.1,3.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c-1.7-0.1-3-1.4-3-3.1V33.5z M8.7,15.1c0-3.8,1.5-5.3,5.2-5.3h16.3c3.7,0,5.2,1.5,5.2,5.3v39.1H24.8V47c0-1.4-1.2-2.6-2.6-2.6 s-2.6,1.2-2.6,2.6v7.2H8.7V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,23.5h12.9c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6H15.8c-1.4,0-2.6,1.2-2.6,2.6 C13.2,22.3,14.4,23.5,15.8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,33.3c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6H15.8c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6 H28.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.5a59bd1e05f91602e8308eb3efc21fee.svg";
export { ForwardRef as ReactComponent };